import { useEffect, useState } from 'react';
import FormGroup from './FormGroup';

const YesNoToggle = ({
    value,
    name,
    label,
    requirementText,
    isRequired,
    showError,
    externalErrorMessage,
    onChange = () => {},
    type,
    placeholder,
    inlineStyle = {},
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const [isValid, setIsValid] = useState(true);

    const checkValidity = value => {
        let valid = true;
        if (isRequired) {
            valid = value.length > 0;
        }
        return valid;
    };

    useEffect(() => {
        setIsValid(checkValidity(value));
        setSelectedValue(value);
    }, [value]);

    const handleChange = event => {
        const value = event.target.value;
        const valid = checkValidity(event.target.value);
        setIsValid(valid);

        setSelectedValue(value);
        onChange(event, true);
    };

    const errorText = showError && !isValid ? requirementText : '';
    const hasError = showError && (!isValid || externalErrorMessage);

    return (
        <FormGroup
            label={label}
            requirementText={requirementText}
            name={name}
            showError={showError}
            externalErrorMessage={errorText}
            required={isRequired}
        >
            <div className="horizontal-toogle-container">
                <span>
                    <input
                        id="yes_option"
                        type="radio"
                        name={name}
                        value="Yes"
                        checked={selectedValue === 'Yes'}
                        className={`form-control ${hasError ? ' toggle-error' : ''}`}
                        onChange={handleChange}
                    />
                    <label htmlFor="yes_option">Yes</label>
                </span>
                <span>
                    <input
                        id="no_option"
                        type="radio"
                        name={name}
                        value="No"
                        checked={selectedValue === 'No'}
                        className={`form-control ${hasError ? ' toggle-error' : ''}`}
                        onChange={handleChange}
                    />
                    <label htmlFor="no_option">No</label>
                </span>
            </div>
        </FormGroup>
    );
};

export default YesNoToggle;
